<template>
  <footer class="footer">
    <div class="footer-section">
      <div class="wrapper">
        <div class="left">
          <div class="logo-container">
            <router-link to="/" class="logo">
              <img src="./../img/logo.svg" class="img" />
            </router-link>
          </div>
          <div class="text">
            <div class="desc">
              {{ $parent.settings.requisites }}<br />
              {{ $parent.settings.support_email }}
            </div>
          </div>
          <div class="socials" v-if="$parent.socialLinks">
            <a
              v-for="link in $parent.socialLinks"
              :href="link.url"
              class="item"
              :key="link.img"
            >
              <div class="image">
                <img
                  v-if="link.image"
                  :src="$parent.imgDomain + '/storage/' + link.image"
                  class="img"
                />
              </div>
            </a>
          </div>
        </div>
        <div class="right">
          <ul class="nav">
            <li class="nav__item">
              <router-link to="/contacts" class="desc">
                CONTACT US
              </router-link>
            </li>
            <li class="nav__item">
              <router-link :to="'/store' + activeCategory.url" class="desc">
                STORE
              </router-link>
            </li>
            <li class="nav__item">
              <router-link to="/faq" class="desc"> FAQ </router-link>
            </li>
            <template v-for="item in textPageList">
              <li class="nav__item" :key="item.id">
                <a class="desc" @click="goToPage(item)">
                  {{ item.title }}
                </a>
              </li>
            </template>
          </ul>
          <div class="desc info-desc">
            minerefcraft is an independent, fan-made project and is not
            affiliated with Mojang Studios, Xbox Game Studios, or Microsoft
            Corporation, the developers and publishers of Minecraft. All related
            trademarks and intellectual property are owned by their respective
            holders.
          </div>
          <ul class="list list-pay">
            <li class="item">
              <img src="./../img/methods/mc.svg" class="img" />
            </li>
            <li class="item">
              <img src="./../img/methods/visa.svg" class="img" />
            </li>
          </ul>
          <div class="copyright desc" v-if="$parent.settings.copyright">
            {{ $parent.settings.copyright }}
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: ["settings", "activeCategory"],
  data: function () {
    return {
      textPageList: [],
    };
  },
  methods: {
    getTextPages() {
      this.$http
        .get(process.env.VUE_APP_API + "static-pages")
        .then((res) => {
          this.textPageList = res.data.payload;
        })
        .catch(() => {});
    },
    goToPage(item) {
      this.$router.push({
        path: "/pages/" + item.url,
        params: { data: item.url },
      });
      this.$emit("getTextPageContent", item.url);
    },
  },
  mounted() {
    this.getTextPages();
  },
};
</script>
